import Vue from 'vue'
import App from './App'
import common from 'plat-common-design'
import 'plat-common-design/lib/common-design.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.config.productionTip = false
import components from '../package/index'
Vue.use(common)
Vue.use(ElementUI)
components.install(Vue);
new Vue({
  render: h => h(App),
}).$mount('#app')
